import { c as _c } from "react/compiler-runtime";
import { Modal, ModalSizeEnum, Popover } from '@systemeio/ui';
import { CustomDomainsStatusEnum, CustomDomainsStatusTitleEnum } from 'modules/profile/custom-domains-settings/enums/custom-domains-settings-enum';
import { CustomDomainsSettingsInterface } from 'modules/profile/custom-domains-settings/types/custom-domains-settings-interface';
import React, { useEffect, useState, type JSX } from 'react';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { DataWithPaginationInterface } from 'shared/types/pagination-interface';
import { getDomainInfoLink } from 'shared/utils/get-domain-info-link';
import { QuestionMarkIcon } from '@systemeio/ui/icons';
interface DnsModalInterface {
  domain: CustomDomainsSettingsInterface;
  needToOpenDns?: number;
}
interface DnsRecordInterface {
  id: string;
  host: string;
  value: string;
}
const DnsModal = t0 => {
  const $ = _c(49);
  const {
    domain,
    needToOpenDns
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  let t1;
  if ($[0] !== domain.id || $[1] !== needToOpenDns) {
    t1 = () => {
      if (needToOpenDns && needToOpenDns === domain.id) {
        setOpened(true);
      }
    };
    $[0] = domain.id;
    $[1] = needToOpenDns;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== domain || $[4] !== needToOpenDns) {
    t2 = [needToOpenDns, domain];
    $[3] = domain;
    $[4] = needToOpenDns;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t1, t2);
  const {
    user
  } = useUser();
  let t3;
  if ($[6] !== domain.status || $[7] !== t) {
    t3 = () => {
      switch (domain.status) {
        case CustomDomainsStatusEnum.aws_caa_failed:
          {
            return <Popover popoverClassName="w-[300px] md:w-[600px]" label={t("dashboard.settings.custom_domains.status.aws_caa_failed_description")}>{_temp}</Popover>;
          }
        case CustomDomainsStatusEnum.aws_cname_already_used:
          {
            return <Popover popoverClassName="w-[300px] md:w-[600px]" label={t("dashboard.settings.custom_domains.status.aws_cname_already_used_description")}>{_temp2}</Popover>;
          }
        case CustomDomainsStatusEnum.deactivated:
          {
            return <Popover popoverClassName="w-[300px] md:w-[600px]" label={t("dashboard.settings.custom_domains.status.deactivated_description")}>{_temp3}</Popover>;
          }
        default:
          {
            return null;
          }
      }
    };
    $[6] = domain.status;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const renderTooltip = t3;
  let t4;
  if ($[9] !== domain.dnsSettings) {
    t4 = domain.dnsSettings ? {
      items: Object.entries(domain.dnsSettings).map(_temp4),
      hasMore: false
    } : {
      items: [],
      hasMore: false
    };
    $[9] = domain.dnsSettings;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const data = t4;
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [{
      key: "first",
      header: "",
      onRender: _temp5,
      onRenderSmall: _temp6,
      widthPercent: 45
    }, {
      key: "second",
      header: "",
      onRender: _temp7,
      onRenderSmall: _temp8,
      widthPercent: 10
    }, {
      key: "third",
      header: "",
      onRender: _temp9,
      onRenderSmall: _temp10,
      widthPercent: 45
    }];
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const columns = t5;
  const t6 = CustomDomainsStatusTitleEnum[domain.status];
  let t7;
  if ($[12] !== t || $[13] !== t6) {
    t7 = t(t6);
    $[12] = t;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <span className="truncate">{t7}</span>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== renderTooltip) {
    t9 = renderTooltip();
    $[17] = renderTooltip;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <div className="flex items-center gap-1">{t8}{t9}</div>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== domain.status || $[23] !== domain.type || $[24] !== t) {
    t11 = domain.type === "aws" && domain.status !== CustomDomainsStatusEnum.aws_remove_in_progress && <button className="primary-link truncate" onClick={() => setOpened(true)}>{t("dashboard.settings.custom_domains.show_instructions")}</button>;
    $[22] = domain.status;
    $[23] = domain.type;
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t) {
    t12 = t("dashboard.settings.custom_domains.dns_configuration");
    $[26] = t;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => setOpened(false);
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== data) {
    t14 = <Table data={data} columns={columns} noHeader={true} />;
    $[29] = data;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  const t15 = user?.dashboardLocale;
  let t16;
  if ($[31] !== t15) {
    t16 = getDomainInfoLink(t15);
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t) {
    t17 = t("dashboard.settings.custom_domains.add_domain_description");
    $[33] = t;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t16 || $[36] !== t17) {
    t18 = <a className="primary-link" href={t16} target="_blank" rel="noreferrer">{t17}</a>;
    $[35] = t16;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t14 || $[39] !== t18) {
    t19 = <div className="flex flex-col items-center gap-5">{t14}{t18}</div>;
    $[38] = t14;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== opened || $[42] !== t12 || $[43] !== t19) {
    t20 = <Modal title={t12} size={ModalSizeEnum.medium} opened={opened} onClose={t13}>{t19}</Modal>;
    $[41] = opened;
    $[42] = t12;
    $[43] = t19;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t10 || $[46] !== t11 || $[47] !== t20) {
    t21 = <div className="flex flex-col gap-3 truncate sm:flex-row">{t10}{t11}{t20}</div>;
    $[45] = t10;
    $[46] = t11;
    $[47] = t20;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  return t21;
};
export default DnsModal;
function _temp(show_1) {
  return <QuestionMarkIcon className={`${show_1 ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
function _temp2(show_0) {
  return <QuestionMarkIcon className={`${show_0 ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
function _temp3(show) {
  return <QuestionMarkIcon className={`${show ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
function _temp4(t0) {
  const [host, value] = t0;
  return {
    id: host,
    host,
    value
  };
}
function _temp5(instance) {
  return <span className="whitespace-normal break-all">{instance.host}</span>;
}
function _temp6(instance_0) {
  return <span className="whitespace-normal break-all">{instance_0.host}</span>;
}
function _temp7() {
  return <span>CNAME</span>;
}
function _temp8() {
  return <span>CNAME</span>;
}
function _temp9(instance_1) {
  return <span className="whitespace-normal break-all">{instance_1.value}</span>;
}
function _temp10(instance_2) {
  return <span className="whitespace-normal break-all">{instance_2.value}</span>;
}